webpackJsonp([100078295327379],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var HeroCTA = function HeroCTA(_ref) {
	    var heromain = _ref.heromain,
	        herosub = _ref.herosub,
	        herourl = _ref.herourl;
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns is-centered' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section home-content' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'has-text-centered' },
	                                _react2.default.createElement(
	                                    'h3',
	                                    { className: 'has-text-weight-semibold is-size-2 has-text-centered' },
	                                    heromain
	                                )
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'h5',
	                                { className: 'has-text-weight-semibold is-size-4 has-text-centered' },
	                                herosub
	                            ),
	                            _react2.default.createElement('br', null),
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'buttons is-centered' },
	                                _react2.default.createElement(
	                                    'a',
	                                    {
	                                        className: 'button is-large is-primary',
	                                        href: herourl },
	                                    'Sign Up'
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        )
	    );
	};
	
	HeroCTA.propTypes = {
	    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({
	        heromain: _propTypes2.default.string,
	        herosub: _propTypes2.default.string,
	        herourl: _propTypes2.default.string
	    }))
	};
	
	exports.default = HeroCTA;
	module.exports = exports['default'];

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.scholarsPageQuery = exports.ScholarsPageTemplate = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(1);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactHelmet = __webpack_require__(13);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _Content = __webpack_require__(39);
	
	var _Content2 = _interopRequireDefault(_Content);
	
	var _NavBar = __webpack_require__(14);
	
	var _NavBar2 = _interopRequireDefault(_NavBar);
	
	var _HeroCTA = __webpack_require__(77);
	
	var _HeroCTA2 = _interopRequireDefault(_HeroCTA);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by vaibhav on 31/3/18
	 */
	var ScholarsPageTemplate = exports.ScholarsPageTemplate = function ScholarsPageTemplate(_ref) {
	    var title = _ref.title,
	        content = _ref.content,
	        contentComponent = _ref.contentComponent,
	        heromain = _ref.heromain,
	        herosub = _ref.herosub,
	        herourl = _ref.herourl;
	
	    var PageContent = contentComponent || _Content2.default;
	
	    return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(_NavBar2.default, null),
	        _react2.default.createElement(
	            'section',
	            { className: 'hero is-primary is-bold' },
	            _react2.default.createElement(
	                'div',
	                { className: 'hero-body' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'container' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'columns' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'column is-10 is-offset-1' },
	                            _react2.default.createElement(
	                                'div',
	                                { className: 'section' },
	                                _react2.default.createElement(
	                                    'h1',
	                                    { className: 'title' },
	                                    title
	                                )
	                            )
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(
	            'section',
	            { className: 'section section--gradient' },
	            _react2.default.createElement(
	                'div',
	                { className: 'container' },
	                _react2.default.createElement(
	                    'div',
	                    { className: 'columns' },
	                    _react2.default.createElement(
	                        'div',
	                        { className: 'column is-10 is-offset-1' },
	                        _react2.default.createElement(
	                            'div',
	                            { className: 'section' },
	                            _react2.default.createElement(PageContent, { className: 'content', content: content })
	                        )
	                    )
	                )
	            )
	        ),
	        _react2.default.createElement(_HeroCTA2.default, { heromain: heromain,
	            herosub: herosub,
	            herourl: herourl })
	    );
	};
	
	ScholarsPageTemplate.propTypes = {
	    title: _propTypes2.default.string.isRequired,
	    content: _propTypes2.default.string,
	    heromain: _propTypes2.default.string,
	    herosub: _propTypes2.default.string,
	    herourl: _propTypes2.default.string,
	    contentComponent: _propTypes2.default.func
	};
	
	var ScholarsPage = function ScholarsPage(_ref2) {
	    var data = _ref2.data;
	    var post = data.markdownRemark;
	
	
	    return _react2.default.createElement(
	        'div',
	        { className: 'scholars' },
	        _react2.default.createElement(
	            _reactHelmet2.default,
	            null,
	            _react2.default.createElement(
	                'title',
	                null,
	                post.frontmatter.meta_title
	            ),
	            _react2.default.createElement('meta', { name: 'description', content: post.frontmatter.meta_description })
	        ),
	        _react2.default.createElement(ScholarsPageTemplate, {
	            contentComponent: _Content.HTMLContent,
	            title: post.frontmatter.title,
	            content: post.html,
	            heromain: post.frontmatter.heromain,
	            herosub: post.frontmatter.herosub,
	            herourl: post.frontmatter.herourl
	        })
	    );
	};
	
	ScholarsPage.propTypes = {
	    data: _propTypes2.default.object
	};
	
	exports.default = ScholarsPage;
	var scholarsPageQuery = exports.scholarsPageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-templates-scholars-page-js-7f6d0a9a635c81a5082c.js